import react from "react";
import "./BMIamges.css";
import BMS1ImgBG from "../../../Assets/images/BoardMembers/BMS1ImgBG.webp";
import { useLocation } from "react-router-dom";
export default function BMImages({ ImgSrc, ImgAlt, Head, Title }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  return (
    <>
      <div className="BMImagesContainer">
        <img src={ImgSrc} alt={ImgAlt} className="BMImages" />
        <img src={BMS1ImgBG} alt="" className="BMImagesShadow" />
        <div className="BMImagesTContainer">
          <div className={`BMImagesHead TGLo32PxPC ${isArabic ? "arabic" : "english"}`}>{Head}</div>
          <div className={`BMImagesTitle TFut24PxPC  ${isArabic ? "arabic" : "english"}`}>{Title}</div>
        </div>
      </div>
    </>
  );
}
